import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { AzureSearchLinkedService } from 'app/model/linkedservice/azure-search.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { azureSearchDomain } from 'app/shared/utils/connector-metadata-static-consts';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSearchLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                key: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class AzureSearchLinkedServiceAdapter extends LinkedServiceAdapter<AzureSearchLinkedService> {
    protected modelConstructor(): new () => AzureSearchLinkedService {
        return AzureSearchLinkedService;
    }

    protected model(): IModel {
        return AzureSearchLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AzureSearchLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AzureSearchLinkedService;

        properties.type = Metamodel.modelFor(AzureSearchLinkedService).name;
        properties.typeProperties = {
            url: 'https://' + linkedService.serviceName + '.' + azureSearchDomain,
            key: passwordOrAKVtoSecretBase(linkedService.key, this.context)
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureSearchLinkedService): Promise<AzureSearchLinkedService> {
        const properties = linkedServiceResource.properties as Model.AzureSearchLinkedService;

        linkedService.serviceName = (properties.typeProperties.url as string)?.replace('https://', '')?.replace('.' + azureSearchDomain, '');
        linkedService.key = secretBaseToPasswordOrAKV(properties.typeProperties.key, true, this.context);
        return linkedService;
    }
}
